import React, { Component } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import { forEach } from "lodash";

import Assignment from "@material-ui/icons/Assignment";
import Checkbox from "@material-ui/core/Checkbox";
import ECCard from "components/EnergyCompany/Cards/ECCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import InfoGrid from "components/EnergyCompany/Grid/InfoGrid.jsx";
import InfoGridItem from "components/EnergyCompany/Grid/InfoGridItem.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Table from "components/Table/Table.jsx";
import { capitalizeString } from "services/utils";

const styles = {
  tableWrapper: {
    marginBottom: "25px",
    "&:last-child": {
      marginBottom: "0",
    },
  },
};

class CCEEData extends Component {
  getData() {
    const { agent, handleProfileCheck, profilesChecked } = this.props;
    let agentTable = { agentCode: agent.code, agentName: agent.name, agentCategory: agent.category, data: [] };

    const getCheckbox = profile => {
      return (
        <Checkbox
          checked={!!profilesChecked[profile.id]}
          onChange={handleProfileCheck}
          value={profile.id}
        />
      );
    };

    forEach(agent.agentProfiles, profile => {
      agentTable.data.push([getCheckbox(profile), profile.code, profile.name, profile.class, profile.status, profile.submarket, profile.retailer ? "Sim" : "Não"]);
    });

    return agentTable;
  };

  getCheckAll() {
    return (
      <Checkbox checked={this.props.allProfilesChecked} onChange={this.props.handleAllProfilesCheck} />
    );
  }

  render() {
    const { classes } = this.props;
    const tableData = this.getData();

    return (
      <GridContainer>
        <GridItem xs={12}>
          <ECCard
            content={
              <div className={classes.tableWrapper}>
                <InfoGrid>
                  <InfoGridItem label="Código do Agente" value={tableData.agentCode} />
                  <InfoGridItem label="Nome" value={tableData.agentName} />
                  <InfoGridItem label="Categoria" value={capitalizeString(tableData.agentCategory)} />
                </InfoGrid>
                <Table
                  colorsColls={["primary"]}
                  tableData={tableData.data}
                  tableHead={[this.getCheckAll(), "Código Perfil", "Sigla", "Classe", "Status", "Submercado", "Perfil Varejista"]}
                  tableHeaderColor="primary"
                />
              </div>
            }
            icon={<Assignment />}
            title="Dados CCEE"
          />
        </GridItem>
      </GridContainer>
    );
  };
};

CCEEData.propTypes = {
  agent: PropTypes.shape({
    agentProfiles: PropTypes.array.isRequired,
    category: PropTypes.string.isRequired,
    code: PropTypes.number.isRequired,
    consolidatedAccountingValues: PropTypes.object.isRequired,
    consolidatedEnergy: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  allProfilesChecked: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  handleAllProfilesCheck: PropTypes.func.isRequired,
  handleProfileCheck: PropTypes.func.isRequired,
  profilesChecked: PropTypes.object.isRequired,
};

export default withStyles(styles)(CCEEData);



// WEBPACK FOOTER //
// ./src/views/Dashboard/partials/CCEEData.jsx